import { useQuery } from "@tanstack/react-query";

import { ONE_SECOND_MS } from "#/config/time";
import { BridgeChainId, isMainnet } from "#/config/web3/contractAddresses";
import { useBridgeFeatureFlag } from "#/hooks/featureFlags/useBridgeFeatureFlag";
import { defaultApiResponseHandler } from "#/services/kyan/kyan.utils";
import { useAccount } from "#/store/wallet/account/account";

import { fetchTokensList } from "../bridge.service";

export const useTokensList = () => {
  const { account } = useAccount();
  const { isBridgeDisabled } = useBridgeFeatureFlag();

  return useQuery({
    queryKey: ["fetchTokensList", account],
    queryFn: () =>
      defaultApiResponseHandler({
        serviceName: "Fetch Token List",
        payload: {
          userAddress: account,
          chainIds: Object.values(BridgeChainId)
            .filter((id) => typeof id === "number")
            .join(","),
        },
        service: fetchTokensList,
      }),
    select: (data) => {
      if (!data.result || isBridgeDisabled) {
        return [];
      }
      return Object.values(data.result).flat();
    },
    // only available on arbitrum mainnet
    enabled: Boolean(account && isMainnet && !isBridgeDisabled),
    staleTime: 30 * ONE_SECOND_MS,
  });
};
